import { getAPIPath, requestGooseAPI } from '../shared/request'
import { LocationClientDto } from '../types/api'
import { CLIENT_LOCATION_ID_PATH } from '../types/constants'

export const ClientLocationService = {
  getLocation: async (locationName: string, locationId: string): Promise<LocationClientDto> => {
    return requestGooseAPI<LocationClientDto>({
      url: getAPIPath(CLIENT_LOCATION_ID_PATH, { locationId: locationName, id: locationId }),
      method: 'GET',
      params: {
        includes: ['address', 'communications', 'subscriberGroup', 'externalAccountLocations.externalAccount'],
      },
    })
  },
}
